import {createLogger} from '@modifi/utilities'

export const logger = createLogger('service:charon')

export const getLogger = (namespaceAddition: string): typeof logger =>
  logger.extend(namespaceAddition)

export {default as TranslatedString} from './translatedString'
export {default as toTitleCase} from './to-title-case'
export {NestedError} from './errors'
export * from './formatAddressData'
